<h2 mat-dialog-title> {{ method.name }}</h2>
<mat-dialog-content class="mat-typography">          
    <mat-icon color="primary" *ngIf="method?.icon">{{method.icon }}</mat-icon>  {{method.name }}
    <div *ngIf="method?.flags">
      <b>Bandeiras:</b> 
      <span *ngFor="let flag of method?.flags; let i = index">
          <span *ngIf="i > 0">,</span>
          {{ flag.name }}                   
      </span>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div  class="toogle" >
    <mat-slide-toggle  [(ngModel)]="active" *ngIf="currentUser.type == 'organization'">Ativo</mat-slide-toggle>
  </div>  
  <button mat-button  color="primary" [mat-dialog-close]="false">Fechar</button>
</mat-dialog-actions>





